import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../molecules/RoundedModal'
import { useComponentModelContext } from '../ComponentModelProvider'
import AddComponentModelForm from './AddComponentModelForm'

const AddComponentModelDialog = React.forwardRef(function AddComponentModelDialog ({ onAdd }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })
  const { componentModel } = useComponentModelContext()
  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const complete = useCallback((componentModel) => {
    close()
    onAdd(componentModel)
  }, [close, onAdd])

  useImperativeHandle(ref, () => ({
    open: (item) => setDialogState({ open: true, processing: false, parent: item })
  }), [setDialogState])

  return (
    <RoundedModal
      title='Add Component Model'
      open={dialogState.open}
      onClose={close}
      position='top'
      disablePortal={false}
    >
      <div>
        <AddComponentModelForm onComplete={complete} classificationTagTypeId={componentModel.classificationTagTypeId} />
      </div>
    </RoundedModal>
  )
})

AddComponentModelDialog.propTypes = {
  onAdd: PropTypes.func.isRequired
}

export default AddComponentModelDialog
